// Reads the exp claim without verifying anything. The server stays the only
// authority on validity: this exists to decide when to ask for a new token.
export function getJwtExpiry(token: string | null | undefined): number | null {
  if (!token) {
    return null;
  }

  const segments: string[] = token.split('.');

  if (segments.length !== 3) {
    return null;
  }

  try {
    const payload: { exp?: unknown } = JSON.parse(decodeBase64Url(segments[1]));

    return typeof payload.exp === 'number' ? payload.exp * 1000 : null;
  } catch {
    return null;
  }
}

function decodeBase64Url(segment: string): string {
  const base64: string = segment.replace(/-/g, '+').replace(/_/g, '/');
  const padded: string = base64.padEnd(base64.length + ((4 - (base64.length % 4)) % 4), '=');
  const binary: string = atob(padded);

  // atob yields one byte per character: percent-decode so that a claim holding
  // non-ASCII text (an accented username) does not break JSON.parse.
  return decodeURIComponent(
    Array.from(binary, char => '%' + char.charCodeAt(0).toString(16).padStart(2, '0')).join('')
  );
}
